module.exports = __webpack_public_path__ + "new2.jpg?b1522ad872a357d2a9027176e9306394";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new2.jpg
// module id = 24
// module chunks = 0